import React from "react";
import PropTypes from 'prop-types';
import { TransactionCard } from "../../../../../../../../CommonComponents/commonStyles";


const IssuedGrantsWeb = props => {
  const { issuedGrants, config, clicked } = props;
  return issuedGrants.map((item, dataIndex) => {
    let configOfTab = config(item, dataIndex, () => clicked(item));
    return (
      <TransactionCard key={dataIndex}>
        {configOfTab[0].config.map(ele => ele.render)}
      </TransactionCard>
    );
  });
};

export default IssuedGrantsWeb;

IssuedGrantsWeb.propTypes = {
  clicked: PropTypes.func,
  issuedGrants: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    availableBalance: PropTypes.number,
    charityName: PropTypes.string,
    checkClearedDate: PropTypes.number,
    checkNumber: PropTypes.number,
    csrDPFlow: PropTypes.bool,
    csrFlow: PropTypes.bool,
    currentBalance: PropTypes.number,
    dateRequested: PropTypes.number,
    dpUser: PropTypes.string,
    dpUserFirstName: PropTypes.string,
    dpUserLastName: PropTypes.string,
    dpUserMiddleName: PropTypes.string,
    dpUserPrefix: PropTypes.string,
    dpUserSuffix: PropTypes.string,
    enteredDate: PropTypes.number,
    grantAgreement: PropTypes.bool,
    isRecurring: PropTypes.string,
    issuedate: PropTypes.number,
    purpose: PropTypes.object,
    status: PropTypes.string,
    stopAndReissueChkDate: PropTypes.number,
    txnId: PropTypes.number,
    userName: PropTypes.string,
    x: PropTypes.number,
    y3: PropTypes.bool,
    y5: PropTypes.bool,
  })),
  config: PropTypes.func
}
